const UPLOAD_REQUEST = 'UPLOAD_REQUEST'
const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS'
const UPLOAD_FAILED = 'UPLOAD_FAILED'

export default {
  UPLOAD_REQUEST,
  UPLOAD_SUCCESS,
  UPLOAD_FAILED
}
